import * as React from 'react';
import { Box, BoxStyle } from '../../components/Box';
import Section from '../../components/Section';
import { StepType, GuideStep, Guide } from '../../guide';

type Props = {
  guide: Guide;
};

export default function GuideStepsSection(props: Props) {
  return (
    <Section title="Steps" bodyStyle={BoxStyle.Padded}>
      {props.guide.steps.map((step: GuideStep, index: number) => (
        <div
          key={index}
          className="flex-ns flex-wrap-s items-center pa3 bb b--black-10 bw1"
        >
          <div className="pr3">
            <img
              className="br-100 w3 h3 dib"
              src={`/images/steps/${step.type}.png`}
              alt="Coffee Dose"
            />
          </div>
          <div className="flex-auto pr3">
            <h4>{step.name}</h4>
            {step.description_text && (
              <p className="black-70 lh-copy">{step.description_text}</p>
            )}
          </div>
          {(step.type === StepType.pour || step.type === StepType.bloom) && (
            <div className="w-50 w-10-ns tc pr3 b">
              <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Amount</h4>
              {step.amount}
              {step.amount_unit}
            </div>
          )}
          {step.time_duration > 0 && (
            <div className="w-50 w-10-ns tc pr3 b">
              <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Duration</h4>
              {step.time_duration}s
            </div>
          )}
        </div>
      ))}
    </Section>
  );
}
